import React from 'react'
import { useI18n } from '../../i18n'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'
import OperationalEventTimeline from './OperationalEventTimeline'

type Props = {
  operationalEvents?: {
    enabled?: boolean
    timeline?: Array<{ id: string; at: string; eventType: string; severity: string; summary: string }>
    regressions?: unknown[]
    recoveries?: unknown[]
    certificationRisk?: unknown[]
  } | null
}

export default function WorkflowOperationalEventsPanel({ operationalEvents }: Props) {
  const { t } = useI18n()
  if (!operationalEvents?.enabled) return null

  return (
    <GovernanceListingSection
      title={t('complianceRuntime.operationalEvent', 'Operational events')}
      description={t('complianceRuntime.workflowTimelineHint', 'Recent regressions, recovery, and certification risk from compliance runtime.')}
    >
      {(operationalEvents.regressions?.length || 0) > 0 ? (
        <p className="text-xs text-red-700 m-0 mb-2">
          {t('complianceRuntime.workflowRegression', 'Workflow regression')}: {operationalEvents.regressions?.length}
        </p>
      ) : null}
      {(operationalEvents.certificationRisk?.length || 0) > 0 ? (
        <p className="text-xs text-amber-800 m-0 mb-2">
          {t('complianceRuntime.certificationRisk', 'Certification risk')}: {operationalEvents.certificationRisk?.length}
        </p>
      ) : null}
      <OperationalEventTimeline items={operationalEvents.timeline || []} compact />
    </GovernanceListingSection>
  )
}
